import { createBrowserRouter } from "react-router";
import { LandingPage } from "@coworker/apprestructured/src/login/components/LandingPage/LandingPage";
import { HomePage } from "@coworker/apprestructured/src/home/components/HomePage/HomePage";
import { TeamSelection } from "@coworker/apprestructured/src/login/components/TeamSelection/TeamSelection";
import { NewUserTeamPage } from "@coworker/apprestructured/src/login/components/NewUserTeamPage/NewUserTeamPage";
import { TeamMembers } from "@coworker/app/src/components/TeamMembers";
import StoreContacts from "@coworker/app/src/components/StoreContacts";
import Insights from "@coworker/apprestructured/src/insights/components/Insights";
import { generateTaskForm } from "@coworker/app/src/components/TaskForm";
import AddonForm from "@coworker/app/src/components/AddonForm";
import { NearbyAddons } from "@coworker/app/src/components/NearbyAddons/NearbyAddons";
import RefillAreasView from "@coworker/apprestructured/src/multi-order-addons/components/RefillAreas/RefillAreasView";
import ItemsSelectionView from "@coworker/apprestructured/src/multi-order-addons/components/ItemsSelection/ItemsSelectionView";
import { PIPHomeView } from "@coworker/app/src/features/PIP/PIPHomeView";
import { PIPStockView } from "@coworker/app/src/features/PIP/PIPStockView";
import { RelatedTasks } from "@coworker/app/src/components/RelatedTasks";
import CustomerMFAQ from "@coworker/app/src/components/MFAQ/CustomerMFAQ";
import NewQuestionMFAQ from "@coworker/app/src/components/MFAQ/NewQuestion";
import CustomerMFAQDetail from "@coworker/app/src/components/MFAQ/QuestionDetailsPage/CustomerMFAQDetail";
import { TestBuyOverview } from "@coworker/app/src/components/TestBuy/Overview/TestBuyOverview";
import { TestBuyDetailPage } from "@coworker/app/src/components/TestBuy/TestBuyDetailPage/TestBuyDetailPage";
import { ArticleDetailsPage } from "@coworker/app/src/components/TestBuy/ArticleDetailPage/ArticleDetailsPage";
import { NewTestBuyForm } from "@coworker/app/src/components/TestBuy/NewTestBuy/NewTestBuyForm";
import { CustomTestBuyForm } from "@coworker/app/src/components/TestBuy/NewTestBuy/CustomTestBuyForm";
import { TestbuyTaskCreationPage } from "@coworker/app/src/components/TestBuy/TaskCreationPage/TestbuyTaskCreationPage";
import { ShoppingToolsOverview } from "@coworker/app/src/components/ShoppingTools/Overview/ShoppingToolsOverview";
import { ProgressOverview } from "@coworker/app/src/components/ShoppingTools/Progress/ProgressOverview";
import { ShowroomOW } from "@coworker/app/src/components/ShoppingTools/Showroom/ShowroomOW";
import { MarkethallOW } from "@coworker/app/src/components/ShoppingTools/Markethall/MarkethallOW";
import { Cashline } from "@coworker/app/src/components/ShoppingTools/Cashline/Cashline";
import { ShoppingToolsSettings } from "@coworker/app/src/components/ShoppingTools/Settings/ShoppingToolsSettings";
import { MediasView } from "@coworker/app/src/components/RoomSettings/Medias/MediasView";
import { TabbedMediaView } from "@coworker/app/src/components/RoomSettings/Medias/TabbedMediaView";
import { GroupView } from "@coworker/app/src/components/RoomSettings/Medias/GroupView";
import { ArticleView } from "@coworker/app/src/components/RoomSettings/Articles/ArticleView";
import { AggregatedArticleView } from "@coworker/app/src/components/RoomSettings/Articles/AggregatedArticleView";
import { CreateTaskView } from "@coworker/app/src/components/RoomSettings/Tasks/CreateTaskView";
import { OngoingTasksListingView } from "@coworker/app/src/components/RoomSettings/Tasks/OngoingTasksListingView";
import { SearchedArticleView } from "@coworker/app/src/components/RoomSettings/Articles/SearchedArticleView";
import { CreateMediaView } from "@coworker/app/src/components/RoomSettings/Medias/CreateMediaView";
import { UpdateMediaView } from "@coworker/app/src/components/RoomSettings/Medias/UpdateMediaView";
import DefaultScannerPage from "@coworker/apprestructured/src/scan-and-search/pages/default-scanner-page/DefaultScannerPage";
import ScannerDebugPage from "@coworker/apprestructured/src/scan-and-search/pages/scanner-debug-page/ScannerDebugPage";
import ComponentDemoPage from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/ComponentDemoPage";
import { MainLayout } from "@coworker/apprestructured/src/layout/components/MainLayout/MainLayout";
import { MsalWrapper } from "@coworker/apprestructured/src/layout/components/MsalWrapper/MsalWrapper";
import TaskTypesPage from "@coworker/apprestructured/src/task-management/demo/pages/TaskTypesPage";
import TaskCardPage from "@coworker/apprestructured/src/task-management/demo/pages/TaskCardPage/TaskCardPage";
import TaskTypesCreatePage from "@coworker/apprestructured/src/task-management/demo/pages/TaskTypesCreatePage/TaskTypesCreatePage";
import TaskTypesListPage from "@coworker/apprestructured/src/task-management/demo/pages/TaskTypesListPage/TaskTypesListPage";
import TaskTypesViewPage from "@coworker/apprestructured/src/task-management/demo/pages/TaskTypesViewPage/TaskTypesViewPage";
import TaskTypesEditPage from "@coworker/apprestructured/src/task-management/demo/pages/TaskTypesEditPage/TaskTypesEditPage";
import TeamsAndUsersOverview from "@coworker/apprestructured/src/teams-management/components/TeamsAndUsersOverview";
import TeamManager from "@coworker/apprestructured/src/teams-management/components/TeamManager";
import TaskManagementDevOnly from "@coworker/apprestructured/src/layout/components/TaskManagementDevOnly/TaskManagementDevOnly";
import FeatureFlagOverviewPage from "@coworker/apprestructured/src/feature-flag-management/components/FeatureFlagOverviewPage";
import { TasksOverview } from "@coworker/apprestructured/src/TasksOverview/components/TasksOverview";

export const router = createBrowserRouter([
  {
    Component: MsalWrapper,
    children: [
      {
        Component: MainLayout,
        children: [
          {
            path: "/",
            Component: LandingPage,
          },
          {
            path: "/login",
            Component: LandingPage,
          },
          {
            path: "/home",
            Component: HomePage,
          },
          {
            path: "/team",
            Component: TeamMembers,
          },
          {
            path: "/contacts",
            Component: StoreContacts,
          },
          {
            path: "/insights",
            Component: Insights,
          },

          // Multi order addons
          {
            path: "/multi-order-addons",
            Component: RefillAreasView,
          },
          { path: "/tasks", Component: TasksOverview },
          {
            path: "/customerquestions",
            Component: CustomerMFAQ,
          },
          // TestBuy
          {
            path: "/testbuy",
            Component: TestBuyOverview,
          },
          // Shopping tools
          {
            path: "/shoppingtools",
            Component: ShoppingToolsOverview,
          },
          // Medias
          {
            path: "/mediamaintenance",
            Component: MediasView,
          },
          {
            path: "/scanner/:type",
            Component: DefaultScannerPage,
          },
          {
            path: "/scanner-debug",
            Component: ScannerDebugPage,
          },
          {
            path: "/tasks/new",
            element: (
              <TaskManagementDevOnly>
                <TaskTypesPage />
              </TaskManagementDevOnly>
            ),
          },
          // Teams manager
          {
            path: "/teams",
            Component: TeamsAndUsersOverview,
          },
          {
            path: "/teams/store/:storeId",
            Component: TeamsAndUsersOverview,
          },
          {
            path: "/teams/store/:storeId/team/:teamId",
            Component: TeamManager,
          },
          {
            path: "/feature-flags",
            Component: FeatureFlagOverviewPage,
          },
          {
            path: "/task-card/:id",
            element: (
              <TaskManagementDevOnly>
                <TaskCardPage />
              </TaskManagementDevOnly>
            ),
          },
          {
            path: "/task-types/create",
            element: (
              <TaskManagementDevOnly>
                <TaskTypesCreatePage />
              </TaskManagementDevOnly>
            ),
          },
          {
            path: "/task-types/:id",
            element: (
              <TaskManagementDevOnly>
                <TaskTypesViewPage />
              </TaskManagementDevOnly>
            ),
          },
          {
            path: "/task-types/:id/edit",
            element: (
              <TaskManagementDevOnly>
                <TaskTypesEditPage />
              </TaskManagementDevOnly>
            ),
          },
          {
            path: "/task-types",
            element: (
              <TaskManagementDevOnly>
                <TaskTypesListPage />
              </TaskManagementDevOnly>
            ),
          },
        ],
      },
      // add routes which doesn't need any header and footer(in our case components which use fullscreen popup)
      {
        path: "/teamselection",
        Component: TeamSelection,
      },
      {
        path: "/newuserteamselection",
        Component: NewUserTeamPage,
      },
      {
        path: "/task/new/addon",
        Component: AddonForm,
      },
      // Tasks - create/edit
      {
        path: "/task/new/product",
        Component: generateTaskForm("product", "create"),
      },
      {
        path: "/task/edit/product_quality/:id",
        Component: generateTaskForm("product_quality", "edit"),
      },
      {
        path: "/task/new/product_quality",
        Component: generateTaskForm("product_quality", "create"),
      },
      {
        path: "/task/edit/product/:id",
        Component: generateTaskForm("product", "edit"),
      },
      {
        path: "/task/new/addon/nearby",
        Component: NearbyAddons,
      },
      {
        path: "/task/edit/addon/:id",
        Component: generateTaskForm("addon_edit", "edit"),
      },
      {
        path: "/task/new/custom",
        Component: generateTaskForm("custom", "create"),
      },
      {
        path: "/task/new/mfaq_followup",
        Component: generateTaskForm("mfaq_followup", "create"),
      },
      {
        path: "/task/edit/mfaq_followup/:id",
        Component: generateTaskForm("mfaq_followup", "edit"),
      },
      {
        path: "/task/edit/custom/:id",
        Component: generateTaskForm("custom", "edit"),
      },
      {
        path: "/task/edit/planned/:id",
        Component: generateTaskForm("planned", "edit"),
      },
      {
        path: "/task/:id/changes",
        Component: generateTaskForm("addon_changes", "complete"),
      },
      { path: "/tasks/related/:id", Component: RelatedTasks },
      {
        path: "/multi-order-addons/refill-area/:refillAreaId",
        Component: ItemsSelectionView,
      },
      {
        path: "/shoppingtools/settings",
        Component: ShoppingToolsSettings,
      },
      {
        path: "/mediamaintenance/tabs/:mediaId",
        Component: TabbedMediaView,
      },
      {
        path: "/mediamaintenance/groups/:groupId",
        Component: GroupView,
      },
      {
        path: "/mediamaintenance/articles/:articleId",
        Component: ArticleView,
      },
      {
        path: "/mediamaintenance/medias/:mediaId/articles/:articleId/product_article_id/:productArticleId",
        Component: AggregatedArticleView,
      },
      {
        path: "/mediamaintenance/:mediaId/articles/:articleId/createtask",
        Component: CreateTaskView,
      },
      {
        path: "/mediamaintenance/articles/search/:productArticleId",
        Component: SearchedArticleView,
      },
      {
        path: "/mediamaintenance/update/:mediaId",
        Component: UpdateMediaView,
      },
      {
        path: "/task/edit/room-settings/:id",
        Component: generateTaskForm("roomsettings_edit", "edit"),
      },
      {
        path: "/shoppingtools/progress",
        Component: ProgressOverview,
      },
      {
        path: "/shoppingtools/progress/showroom/:id",
        Component: ShowroomOW,
      },
      {
        path: "/shoppingtools/progress/markethall/:id",
        Component: MarkethallOW,
      },
      {
        path: "/shoppingtools/progress/cashline/:id",
        Component: Cashline,
      },
      {
        path: "/customerquestions/new",
        Component: NewQuestionMFAQ,
      },
      {
        path: "/customerquestions/:id",
        Component: CustomerMFAQDetail,
      },
      { path: "/product/:full_id", Component: PIPHomeView },
      { path: "/product/:full_id/stock", Component: PIPStockView },

      {
        path: "/testbuy/:id",
        Component: TestBuyDetailPage,
      },
      {
        path: "/testbuy/:id/article/:articleId",
        Component: ArticleDetailsPage,
      },
      {
        path: "/testbuy/new",
        Component: NewTestBuyForm,
      },
      {
        path: "/testbuy/custom/:location",
        Component: CustomTestBuyForm,
      },
      {
        path: "/testbuy/:id/article/:articleId/createTask",
        Component: TestbuyTaskCreationPage,
      },
      {
        path: "/mediamaintenance/create",
        Component: CreateMediaView,
      },
      {
        path: "/mediamaintenance/tasks",
        Component: OngoingTasksListingView,
      },
      {
        path: "/task-management-components",
        element: (
          <TaskManagementDevOnly>
            <ComponentDemoPage />
          </TaskManagementDevOnly>
        ),
      },
    ],
  },
]);
